import { updateEditProfileInfo } from "../../../actions/EditProfileInfo/UpdateEditProfileInfo";
import showToaster from "../../../helpers/showToaster";
import PopulateData from "../../../helpers/populateData";
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
    let today, birthDate, age, monthDifference, dateOfMonth, dobDate, monthValidation, isLoading;
    dateOfMonth = Number(values?.month) + 1;
    dobDate = values?.year + '/' + dateOfMonth + '/' + values?.day;
    monthValidation = parseInt(values?.month);

    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;

    if (!values?.day || !values?.year || isNaN(monthValidation)) {
        showToaster({ messageId: 'birthDayField', toasterType: 'error' })
        return false;
    }

    today = new Date();
    birthDate = new Date(dobDate);
    age = today?.getFullYear() - birthDate?.getFullYear();
    monthDifference = today?.getMonth() - birthDate?.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today?.getDate() < birthDate?.getDate())) age--;
    if (age < 18) {
        showToaster({ messageId: 'ageLimit', toasterType: 'error' })
        return false;
    }

    if (values?.year && values?.month && values?.day) {
        if (!PopulateData?.isValidDate(values?.year, values?.month, values?.day)) {
            showToaster({ messageId: 'invalidDob', toasterType: 'error' })
            return false;
        }
    }

    let profileId, firstName, lastName, gender, month;
    let day, year, dateOfBirth, location, email;
    let info, phoneNumber, countryCode, countryName, displayName;

    profileId = values?.profileId;
    firstName = values?.firstName;
    lastName = values?.lastName;
    gender = values?.gender;
    month = values?.month;
    day = values?.day;
    year = values?.year;
    dateOfBirth = (Number(month) + 1) + '-' + year + '-' + day;
    location = values?.location;
    email = values?.profileBanStatus?.email;
    info = values?.info;
    countryName = values?.phoneCountryCode ? values?.phoneCountryCode : countryName;
    phoneNumber = values?.phoneNumber ? values?.phoneNumber.trim() : values?.phoneNumber;
    countryCode = values?.phoneDialCode ? values?.phoneDialCode : values?.dialCode;
    displayName = values?.firstName + values?.lastName;

    dispatch(updateEditProfileInfo({
        profileId,
        firstName,
        lastName,
        gender,
        dateOfBirth,
        location,
        email,
        info,
        phoneNumber,
        countryCode,
        countryName,
        displayName
    }))
}

export default submit;